import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('groups');

const reducer = handleActions(
  {
    [actions.api.groups.request]: () => ({
      isFetching: true,
      isError: false,
    }),
    [actions.api.groups.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.groups.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
  },
  { ...apiModuleDefaultState, data: [], error: null }
);

export default reducer;
